import { render } from "./LogoOverlayComponent.vue?vue&type=template&id=5b59a7e0&scoped=true&ts=true"
import script from "./LogoOverlayComponent.vue?vue&type=script&lang=ts"
export * from "./LogoOverlayComponent.vue?vue&type=script&lang=ts"

import "./LogoOverlayComponent.vue?vue&type=style&index=0&id=5b59a7e0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b59a7e0"]])

export default __exports__